import React from 'react'
import { getAssignmentType } from '../../utils/getAssignmentType'
import CareerQuizSubmission from '../CareerQuizSubmission/CareerQuizSubmission'
import CareerEssaySubmission from '../CareerEssaySubmission/CareerEssaySubmission'
import CountryExplorationSubmission from '../CountryExplorationSubmission/CountryExplorationSubmission'
import UniversityExplorationSubmission from '../UniversityExplorationSubmission/UniversityExplorationSubmission'
import PathwayAlignmentSubmission from '../PathwayAlignmentSubmission/PathwayAlignmentSubmission'
import ClassPresentationSubmission from '../ClassPresentationSubmission/ClassPresentationSubmission'
import ProfileBuildingSubmission from '../ProfileBuildingSubmission/ProfileBuildingSubmission'

/**
 * Router component that renders the appropriate submission component
 * based on assignment type
 */
const AssignmentSubmissionRouter = ({ assignment, student }) => {
	const assignmentType = getAssignmentType(assignment)

	if (!assignmentType) {
		return null
	}

	switch (assignmentType) {
		case 'career_quiz':
			return <CareerQuizSubmission assignment={assignment} student={student} />
		
		case 'career_essay':
			return <CareerEssaySubmission assignment={assignment} student={student} />
		
		case 'country_exploration':
			return <CountryExplorationSubmission assignment={assignment} student={student} />
		
		case 'university_exploration':
			return <UniversityExplorationSubmission assignment={assignment} student={student} />
		
		case 'pathway_alignment':
			return <PathwayAlignmentSubmission assignment={assignment} student={student} />
		
		case 'class_presentation':
			return <ClassPresentationSubmission assignment={assignment} student={student} />
		
		case 'profile_building':
			return <ProfileBuildingSubmission assignment={assignment} student={student} />
		
		default:
			return null
	}
}

export default AssignmentSubmissionRouter
